import { render } from "./PayModal.vue?vue&type=template&id=63fbf09e&ts=true"
import script from "./PayModal.vue?vue&type=script&lang=ts"
export * from "./PayModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__